import { createSessionStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/session-storage/index.tsx';
import { PACKAGE_NAME } from '../consts.tsx';
import { toErrorId, toErrorMessage, type Avatar } from '../types.tsx';
import { logError } from '../util/error-logger.tsx';

const AVATARS_ISSUE_TYPE_PREFIX = 'AVATARS_ISSUE_TYPE';
const storage = createSessionStorageProvider('avatar-modal');

const buildStorageKey = (projectId: number) => `${AVATARS_ISSUE_TYPE_PREFIX}_${String(projectId)}`;

const init = (projectId: number, avatars: Avatar[]): void => {
	storage.set(buildStorageKey(projectId), JSON.stringify(avatars));
};

const get = (projectId: number): Avatar[] => {
	const serializedAvatars: string = storage.get(buildStorageKey(projectId));
	if (!serializedAvatars) {
		return [];
	}
	try {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return JSON.parse(serializedAvatars) as Avatar[];
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		logError(
			PACKAGE_NAME,
			toErrorId('avatarStorage'),
			toErrorMessage('Saved issue type avatars are corrupted in session storage'),
			error,
		);

		return [];
	}
};

const update = (projectId: number, avatar: Avatar): void => {
	const avatars = get(projectId);
	if (!avatars) {
		init(projectId, [avatar]);
	} else {
		storage.set(buildStorageKey(projectId), JSON.stringify([...avatars, avatar]));
	}
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default {
	init,
	get,
	update,
};
